export const fixAssetsPath = (str) => {
    return str.replace(/\/?$/, "/");
};
//# sourceMappingURL=utils.js.map
